import {
    NgModule
} from '@angular/core';
import {
    CommonModule
} from '@angular/common';
import {
    FormsModule
} from '@angular/forms';
import {
    RouterModule
} from '@angular/router';
import {
    IonicModule
} from '@ionic/angular';
import {
    ApperyioTranslateModule
} from '../../scripts/apperyio/translate_module';
import {
    ApperyioDeclarablesModule
} from '../../scripts/apperyio/declarables/apperyio.declarables.module';
import {
    PhoneInput
} from './PhoneInput';
import {
    PipesModule
} from '../../scripts/pipes.module';
import {
    DirectivesModule
} from '../../scripts/directives.module';
import {
    ComponentsModule
} from '../../scripts/components.module';
import {
    CustomModulesModule
} from '../../scripts/custom-modules.module';
import {
    IonicSelectableModule
} from 'ionic-selectable';
import {
    SimpleMaskModule
} from 'ngx-ion-simple-mask';
@NgModule({
    declarations: [
        PhoneInput
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
        DirectivesModule,
        ComponentsModule,
        ApperyioDeclarablesModule,
        CustomModulesModule, IonicSelectableModule,
        SimpleMaskModule, RouterModule,
        ApperyioTranslateModule
    ],
    exports: [
        PhoneInput
    ],
    entryComponents: [
        PhoneInput
    ]
})
export class PhoneInputComponentModule {}